// Class: starling.filters.IFilterHelper

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var IFilterHelper = function() {}

// Meta

IFilterHelper.__name__ = ["starling","filters","IFilterHelper"];
IFilterHelper.prototype = {
	
};
IFilterHelper.prototype.__class__ = IFilterHelper.prototype.constructor = $hxClasses["starling.filters.IFilterHelper"] = IFilterHelper;

// Init



// Statics




// Export

exports.default = IFilterHelper;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/IFilterHelper.js
// module id = 199
// module chunks = 0